import React from "react";

// Sedm fází technologie; fáze případu se z nich dopočítává na serveru
// (nejpomalejší živá technologie). Kódy zůstaly kvůli datům: NOVY = Poptávka,
// REALIZACE = Montáž, DOKONCENO = Předáno.
export const FAZE_ORDER = ["NOVY", "ZAMERENI", "NABIDKA", "OBJEDNANO", "REALIZACE", "DOKONCENO", "ZTRACENO"];
export const FAZE_LABEL = {
  NOVY: "Poptávka", ZAMERENI: "Zaměření", NABIDKA: "Nabídka", OBJEDNANO: "Objednáno",
  REALIZACE: "Montáž", DOKONCENO: "Předáno", ZTRACENO: "Ztraceno",
};
export const PIPELINE_FAZE = ["NOVY", "ZAMERENI", "NABIDKA", "OBJEDNANO", "REALIZACE"];

// Vlastní fáze firmy (Nastavení → Fáze a úkoly): názvy přepíšou FAZE_LABEL na místě,
// mezikroky jsou stavy uvnitř Poptávky nebo Nabídky (`faze`, starší bez ní = Nabídka).
// Etapa = kód fáze, u technologie/případu v mezikroku „M:id“.
const VYCHOZI_NAZVY = { ...FAZE_LABEL };
let MEZIKROKY = [];
let ZAMERENI_V_KALENDARI = true;
export function nastavFaze(nastaveni) {
  Object.assign(FAZE_LABEL, VYCHOZI_NAZVY, nastaveni?.nazvy || {});
  MEZIKROKY = (nastaveni?.mezikroky || []).filter((m) => m.id && m.nazev)
    .map((m) => ({ ...m, faze: m.faze === "NOVY" ? "NOVY" : "NABIDKA" }));
  ZAMERENI_V_KALENDARI = nastaveni?.zamereni_v_kalendari !== false;
}
export const vychoziNazvy = () => VYCHOZI_NAZVY;
export const zamereniVKalendari = () => ZAMERENI_V_KALENDARI;
/** Mezikroky firmy; s `faze` jen ty dané fáze. */
export const mezikroky = (faze) => (faze ? MEZIKROKY.filter((m) => m.faze === faze) : MEZIKROKY);
export const etapa = (x) =>
  (x?.mezikrok && MEZIKROKY.some((m) => m.id === x.mezikrok && m.faze === x?.faze) ? `M:${x.mezikrok}` : x?.faze);
export const nazevEtapy = (k) => {
  if (typeof k === "string" && k.startsWith("M:")) {
    const m = MEZIKROKY.find((x) => `M:${x.id}` === k);
    return m?.nazev || FAZE_LABEL.NABIDKA;
  }
  return FAZE_LABEL[k] || k;
};
const mk = (faze) => mezikroky(faze).map((m) => `M:${m.id}`);
/** Pás a tabule: fáze s mezikroky firmy (za Poptávkou a mezi Nabídkou a Objednáno). */
export const pipelineEtapy = () => [
  "NOVY", ...mk("NOVY"), "ZAMERENI", "NABIDKA", ...mk("NABIDKA"), ...PIPELINE_FAZE.slice(3)];
// Jedna barevná sada fází pro celou aplikaci (seznam, detail případu,
// technologie, přehled). Dřív měl každý screen vlastní a Nabídka s Realizací
// byly stejně oranžové. `col` = text štítku, `bg` = podklad, `dot` = tečka/pás.
export const FAZE_BARVA = {
  NOVY: { col: "#4a5563", bg: "#f2f4f6", dot: "#94a3b8", silna: "#64748b" },
  ZAMERENI: { col: "#0e6f7a", bg: "#e6f5f6", dot: "#22a3b0", silna: "#1a97a4" },
  NABIDKA: { col: "#24589f", bg: "#eef4fd", dot: "#4f8ef0", silna: "#3f7fe0" },
  OBJEDNANO: { col: "#5b3fb0", bg: "#f1edfc", dot: "#9a76e6", silna: "#8a63e0" },
  REALIZACE: { col: "#a8410c", bg: "#fbe6d8", dot: "#ff6a13", silna: "#ff6a13" },
  DOKONCENO: { col: "#0f6b53", bg: "#eaf6f1", dot: "#17876a", silna: "#17876a" },
  ZTRACENO: { col: "#a32418", bg: "#fdeceb", dot: "#d93a2b", silna: "#d93a2b" },
};
// Mezikroky poptávky leží mezi šedou Poptávkou a tyrkysovým Zaměřením.
const POPTAVKA_BARVY = [
  { col: "#3f5566", bg: "#eef3f6", dot: "#7c97aa", silna: "#5f7d92" },
  { col: "#2f5f6c", bg: "#eaf3f5", dot: "#5f9fae", silna: "#4a8b9a" },
];
// Mezikroky nabídky leží mezi modrou Nabídkou a fialovým Objednáno.
const MEZI_BARVY = [
  { col: "#33479f", bg: "#eef0fc", dot: "#6478ea", silna: "#5668de" },
  { col: "#433ea8", bg: "#efeefc", dot: "#7a6fec", silna: "#6c60e2" },
  { col: "#4f3aa8", bg: "#f1edfc", dot: "#8a72ea", silna: "#7c62e0" },
];
export const fazeBarva = (f) => {
  if (typeof f === "string" && f.startsWith("M:")) {
    const m = MEZIKROKY.find((x) => `M:${x.id}` === f);
    const ve = mezikroky(m?.faze || "NABIDKA");
    const i = Math.max(0, ve.findIndex((x) => `M:${x.id}` === f));
    const sada = m?.faze === "NOVY" ? POPTAVKA_BARVY : MEZI_BARVY;
    return sada[i % sada.length];
  }
  return FAZE_BARVA[f] || FAZE_BARVA.NOVY;
};

export function FazeDot({ faze, className = "h-2 w-2" }) {
  return <span className={`rounded-full inline-block ${className}`} style={{ background: fazeBarva(faze).dot }} />;
}

/** Štítek fáze (3A): barevná tečka a název, bez podbarvení. */
export function FazePill({ faze }) {
  const b = fazeBarva(faze);
  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-[12.5px] font-600 transition-colors duration-200"
      style={{ color: b.col }}>
      <span className="h-[7px] w-[7px] rounded-full shrink-0" style={{ background: b.dot }} />
      {nazevEtapy(faze)}
    </span>
  );
}
